import { service } from '@maia/cart';
import { ICartEntity } from '@maia/shared';
import { useMutation } from '@tanstack/react-query';

type UseCreateCartParams = Parameters<typeof service.createCart>[1];

export function useCreateCart(
  customerGuid: string,
  params: Omit<UseCreateCartParams, 'selectedProducts'>,
  onSuccess?: (data: ICartEntity) => void,
) {
  return useMutation({
    mutationFn: (
      selectedProducts: Pick<UseCreateCartParams, 'selectedProducts'>,
    ) =>
      service.createCart(`${customerGuid}/carts`, {
        ...params,
        ...selectedProducts,
      }),
    onSuccess,
  });
}
